import { useQuery } from '@tanstack/react-query';
import { gqlClient } from '../clients';
import { graphql } from '../gql/gql';
import { queryClient } from '../query-client';
import { coreApiKeys } from './keys';

const cmsConfig = graphql(/* GraphQL */ `
  query composite_cmsConfig {
    composite_cmsConfig {
      url
      token
    }
  }
`);

const cmsConfigQuery = {
  queryKey: coreApiKeys.cmsConfig(),
  queryFn: async () => gqlClient.request(cmsConfig),
};

export function getCmsConfig() {
  return queryClient.fetchQuery(cmsConfigQuery);
}

export function useCmsConfig() {
  return useQuery({
    ...cmsConfigQuery,
    select: ({ composite_cmsConfig }) => composite_cmsConfig,
  });
}
